import { InsuranceProduct } from "Store/interfaces/products/checkout";

export interface ProductNameNinValidationRequest {
  updatedProduct?: InsuranceProduct;
  childHealthProduct?: InsuranceProduct;
  productId: string;
  personInfo: PersonInfo;
  verifyNotSameAsCustomer?: boolean;
}

export interface PersonInfo {
  firstName: string;
  lastName: string;
  nin: string;
}

export interface ProductNameNinValidationState {
  personInfo?: PersonInfo;
  isLoading: boolean;
  error?: ProductNameNinValidationErrorType;
}

export interface ValidateProductNameNinState {
  [productId: string]: ProductNameNinValidationState;
}

export enum ProductNameNinValidationErrorType {
  INVALID_PRODUCT_COMPOSITION = "Invalid Product Composition",
  NOT_VALID_PERSON_STATUS = "NOT VALID PERSON STATUS",
  MISMATCH_NIN_AND_DATE_OF_BIRTH = "MISMATCH_NIN_AND_DATE_OF_BIRTH",
  NIN_IS_EQUAL_TO_MEMBER_NIN = "NIN_IS_EQUAL_TO_MEMBER_NIN",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
}
